import { logDispatcher } from "src/app/core/decorators/state.decorators";

export namespace AttendanceStatusActions {

  @logDispatcher
  export class GetAttendanceStatus {
    static readonly type = '[AttendanceStatus] GetAttendanceStatus';
    constructor() {}
  }

}
